module.exports = __webpack_public_path__ + "img/td.888108d4.svg";